import { z } from "zod";

/**
 * Regex de validación de contraseña — fuente de verdad: back/src/auth/dto/activate-account.dto.ts
 */
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

/**
 * Valida una contraseña contra las reglas de complejidad del backend.
 * Retorna errores específicos por cada criterio que no se cumpla.
 */
export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push("La contraseña debe tener al menos 8 caracteres");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("Debe contener al menos una letra mayúscula");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("Debe contener al menos una letra minúscula");
  }
  if (!/\d/.test(password)) {
    errors.push("Debe contener al menos un número");
  }
  if (!/[@$!%*?&]/.test(password)) {
    errors.push("Debe contener al menos un carácter especial (@$!%*?&)");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

/**
 * Schema Zod reutilizable para campos de contraseña.
 * Usa superRefine para integrar validatePassword con los schemas existentes.
 */
export const passwordSchema = z.string().superRefine((val, ctx) => {
  const { errors } = validatePassword(val);
  for (const msg of errors) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: msg,
    });
  }
});
